import { InjectionToken, inject } from '@angular/core';
import { OpenFirestoreClient, injectFirestoreClient } from '@open/ngx-firebase/firestore';

export type ListOfCollections =
  | 'VALIDATED_MASKS'
  | 'AGENCIES'
  | 'AGENCY_ADMINS'
  | 'BENEFICIARIES'
  | 'COMPANIES'
  | 'DISCRETE_VOUCHERS'
  | 'EMAIL_EVENTS'
  | 'INVOICES'
  | 'ORDERS'
  | 'PAYBACKS'
  | 'PINS'
  | 'PROVISIONS'
  | 'USERS'
  | 'VAT'
  | 'OPEN_BANKING_BANKS'
  | 'SCAN_TRANSACTIONS_TEST'
  | 'APP_AVAILABILITY'
  | 'OPEN_BANKING_TOKENS'
  | 'COUNTERS'
  | 'PUBLIC_HOLIDAYS'
  | 'BUSINESSES'
  | 'BUSINESS_ADMINS'
  | 'BUSINESS_CASHIER'
  | 'COUNTRY_FLAGS'
  | 'STATEMENTS'
  | 'PAYMENT_TRANSACTIONS'
  | 'YEARLY_MILLESIME_METADATA'
  | 'CONTRACT_BASED_MILLESIME_METADATA'
  | 'MILLESIME_REPORTS'
  | 'OPEN_BANKING_SYNC_STATUS'
  | 'ANALYTICS'
  | 'MERCHANT_AGREEMENTS' // Conventionnements, read directly by the eligible-businesses list
  ;

export type BeneficiaryDb = OpenFirestoreClient<ListOfCollections>;

// Token-backed so specs can `{ provide: BENEFICIARY_DB, useValue: stub }`.
export const BENEFICIARY_DB: InjectionToken<BeneficiaryDb> = new InjectionToken<BeneficiaryDb>('BENEFICIARY_DB', {
  providedIn: 'root',
  factory: (): BeneficiaryDb => injectFirestoreClient<ListOfCollections>(),
});

export function injectDb(): BeneficiaryDb {
  return inject(BENEFICIARY_DB);
}
